<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="subject">{{subject.name}}</template><template v-if="subject && subject.unit">(单位:{{subject.unit}})</template> - 明细账 </span>
		</div>
		<div class="margin-right-left margin-top no-print">
			<account-date-choose v-model="accountDate"/>
			<span class="range-sep">至</span>
			<DatePicker type="month" v-model="endMonth" format="YYYY-MM" placeholder="结束月份(可选)" :clearable="true" style="width: 130px; vertical-align: middle;"></DatePicker>
			<div class="float-right">
				<Checkbox :disabled="numPriceDisabled" v-model="showNumPrice">显示数量金额</Checkbox>
				<Button icon="fa fa-download" @click="doExport">导出</Button>
				<Button icon="fa fa-print" @click="doPrint">打印</Button>
			</div>
		</div>
		<Row class="h-panel-body" type="flex" :space-x="10">
			<Cell :flex="1" style="overflow-x: auto;">
				<div class="print-header">
					<div class="print-title"><template v-if="subject">{{subject.name}}</template>明细账</div>
					<div class="print-sub">
						<span>编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
						<span>期间：{{printPeriod}}</span>
						<span>单位：元</span>
					</div>
				</div>
				<table class="cus-table" v-if="!showNumPrice">
					<thead class="header">
					<tr>
						<td>日期</td>
						<td>凭证字号</td>
						<td>科目</td>
						<td>摘要</td>
						<td>借方</td>
						<td>贷方</td>
						<td>方向</td>
						<td>余额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in datalist" :key="item.subjecId">
						<td>{{item.voucherDate}}</td>
						<td>
							<router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
						</td>
						<td>{{item.subjectName}}</td>
						<td>{{item.summary}}</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td class="text-center" :class="{'abnormal-balance':isAbnormalBalance(item)}">{{item.balanceDirection}}</td>
						<td class="text-right" :class="{'abnormal-balance':isAbnormalBalance(item)}">{{item.balance|numFormat}}</td>
					</tr>
					<tr v-if="!datalist.length">
						<td colspan="8" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
				<table class="cus-table" style="width: 1550px;" v-else>
					<thead class="header">
					<tr>
						<td rowspan="2" width="100">日期</td>
						<td rowspan="2" width="100">凭证字号</td>
						<td rowspan="2" width="150">科目</td>
						<td rowspan="2" width="200">摘要</td>
						<td colspan="3">借方发生额</td>
						<td colspan="3">贷方发生额</td>
						<td colspan="4">余额</td>
					</tr>
					<tr>
						<td width="100">数量</td>
						<td width="100">单价</td>
						<td width="100">金额</td>
						<td width="100">数量</td>
						<td width="100">单价</td>
						<td width="100">金额</td>
						<td width="100">方向</td>
						<td width="100">数量</td>
						<td width="100">单价</td>
						<td width="100">金额</td>
					</tr>
					</thead>
					<tbody>
					<tr v-for="item in datalist" :key="item.subjecId">
						<td>{{item.voucherDate}}</td>
						<td>
							<router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}">{{item.word}}-{{item.code}}</router-link>
						</td>
						<td class="nowrap">{{item.subjectName}}</td>
						<td class="nowrap">{{item.summary}}</td>
						<td class="text-right">{{item.debitAmount ? (item.creditAmount ? item.debitNum : item.num) : ''}}</td>
						<td class="text-right">{{item.debitAmount&&item.balanceDirection=='借'?item.price:''}}</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount ? (item.debitAmount ? item.creditNum : item.num) : ''}}</td>
						<td class="text-right">{{item.creditAmount&&item.balanceDirection=='贷'?item.price:''}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td class="text-center" :class="{'abnormal-balance':isAbnormalBalance(item)}">{{item.balanceDirection}}</td>
						<td class="text-right">{{item.numBalance|numFormat}}</td>
						<td class="text-right">{{item.price|numFormat}}</td>
						<td class="text-right" :class="{'abnormal-balance':isAbnormalBalance(item)}">{{item.balance|numFormat}}</td>
					</tr>
					<tr v-if="!datalist.length">
						<td colspan="8" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
			</Cell>
			<Cell v-width="200" class="no-print">
				<Tree v-model="subjectId" @select="subjectSelect" :option="param" ref="subject" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
			</Cell>
		</Row>
	</app-content>
</template>

<script>
	import moment from 'moment';
	import {mapState} from 'vuex';
	import {exportCsv} from '../../js/common/export-file';

	export default {
		name: 'DetailedAccounts',
		data() {
			return {
				loading: false,
				param: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'subjectFullName',
					dataMode: 'list',
					datas: []
				},
				datalist: [],
				subjectId: null,
				showNumPrice: false,
				numPriceDisabled: true,
				accountDate: null,
				endMonth: null,
				subject: null,
				//从其他账簿联查跳转时待定位的科目编码
				pendingSubjectCode: null
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			printPeriod() {
				if (!this.accountDate) {
					return '';
				}
				let s = moment(this.accountDate).format('YYYY年MM月');
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('YYYY年MM月');
				}
				return s;
			}
		},
		watch: {
			subject() {
				let org = this.showNumPrice;
				if (this.subject.unit) {
					this.numPriceDisabled = false;
					this.showNumPrice = true;
				} else {
					this.showNumPrice = false;
				}
				if (org == this.showNumPrice) {
					this.loadList();
				}
			},
			showNumPrice() {
				this.loadList();
			},
			accountDate() {
				this.loadSubject();
			},
			endMonth() {
				this.loadList();
			}
		},
		methods: {
			loadSubject() {
				this.datalist = [];
				this.$api.accountbook.loadSubject({accountDate: this.accountDate}).then(({data}) => {
					this.$set(this.param, "datas", data);
					if (data.length) {
						let target = null;
						if (this.pendingSubjectCode) {
							//优先精确匹配，未命中时匹配该科目的首个下级（汇总/总账可能点到父级科目）
							target = data.find(s => s.code === this.pendingSubjectCode)
								|| data.find(s => s.code && s.code.indexOf(this.pendingSubjectCode) === 0);
							this.pendingSubjectCode = null;
						}
						if (!target) {
							target = data[0];
						}
						this.subjectId = target.id;
						this.subject = target;
					}
				});
			},
			loadList() {
				if (!this.subject) {
					return;
				}
				this.loading = true;
				let params = {
					accountDate: this.accountDate,
					subjectId: this.subjectId,
					showNumPrice: this.showNumPrice,
					subjectCode: this.subject.code
				};
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
				}
				this.$api.accountbook.loadVoucherDetails(params).then(({data}) => {
					this.datalist = data;
					this.loading = false;
				});
			},
			subjectSelect(node) {
				this.subject = node;
			},
			//余额方向与科目默认方向相反且余额非零时视为异常（如资产类科目挂出贷方余额），红字提示
			isAbnormalBalance(item) {
				return !!(this.subject && this.subject.balanceDirection
					&& item.balanceDirection && item.balanceDirection !== '平'
					&& item.balanceDirection !== this.subject.balanceDirection
					&& Number(item.balance) !== 0);
			},
			doExport() {
				if (!this.datalist.length) {
					this.$Message.error('暂无数据可导出');
					return;
				}
				let name = this.subject ? this.subject.name : '';
				let headers, rows;
				if (!this.showNumPrice) {
					headers = ['日期', '凭证字号', '科目', '摘要', '借方', '贷方', '方向', '余额'];
					rows = this.datalist.map(item => [
						item.voucherDate ? moment(item.voucherDate).format('YYYY-MM-DD') : '',
						item.word && item.code ? item.word + '-' + item.code : '',
						item.subjectName, item.summary,
						item.debitAmount, item.creditAmount, item.balanceDirection, item.balance
					]);
				} else {
					headers = ['日期', '凭证字号', '科目', '摘要',
						'借方数量', '借方单价', '借方金额', '贷方数量', '贷方单价', '贷方金额',
						'余额方向', '余额数量', '余额单价', '余额金额'];
					rows = this.datalist.map(item => [
						item.voucherDate ? moment(item.voucherDate).format('YYYY-MM-DD') : '',
						item.word && item.code ? item.word + '-' + item.code : '',
						item.subjectName, item.summary,
						item.debitAmount ? (item.creditAmount ? item.debitNum : item.num) : '',
						item.debitAmount && item.balanceDirection === '借' ? item.price : '',
						item.debitAmount,
						item.creditAmount ? (item.debitAmount ? item.creditNum : item.num) : '',
						item.creditAmount && item.balanceDirection === '贷' ? item.price : '',
						item.creditAmount,
						item.balanceDirection, item.numBalance, item.price, item.balance
					]);
				}
				exportCsv('明细账-' + name + (this.accountDate ? '-' + moment(this.accountDate).format('YYYYMM') : '') + (this.endMonth ? '-' + moment(this.endMonth, 'YYYY-MM').format('YYYYMM') : ''), headers, rows);
			},
			doPrint() {
				window.print();
			}
		},
		mounted() {
			//账簿联查入口：接收科目编码与期间参数
			let q = this.$route.query || {};
			if (q.subjectCode) {
				this.pendingSubjectCode = q.subjectCode;
			}
			if (q.endMonth) {
				this.endMonth = q.endMonth;
			}
			if (q.accountDate && q.accountDate !== this.accountDate) {
				this.accountDate = q.accountDate;
			}
		}
	};
</script>

<style lang="less" scoped>
	.range-sep {
		margin: 0 8px;
		line-height: 30px;
		vertical-align: middle;
	}
	.abnormal-balance {
		color: #f56c6c;
		font-weight: bold;
	}
</style>
